import axios from '@axios'

const PREFIX = '/pacote-servicos'

export default {
  getPacotesServicos(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },

  getPacoteServico(id) {
    return axios.get(`${PREFIX}/${id}`)
  },

  getPacoteServicoCopia(id) {
    return axios.get(`${PREFIX}/copia?id=${id}`)
  },

  createPacoteServico(pacoteServico) {
    return axios.post(`${PREFIX}/add`, pacoteServico)
  },

  updatePacoteServico(id, pacoteServico) {
    return axios.put(`${PREFIX}/${id}`, pacoteServico)
  },

  deletePacoteServico(id) {
    return axios.delete(`${PREFIX}/${id}`)
  },

  existePacoteServico(pacote, competencia, copia) {
    return axios.post(`${PREFIX}/existe?competencia=${competencia}&copia=${copia}`, pacote)
  },

  getServicosDepartamentos() {
    return axios.get(`${PREFIX}/servicos-departamento`)
  },

  getPacoteServicosResumidos(filtros) {
    return axios.post(`${PREFIX}/resumida`, filtros)
  },

  possuiProposta(id) {
    return axios.get(`${PREFIX}/possui-proposta/${id}`)
  },

  existePacoteHonorario() {
    return axios.get(`${PREFIX}/existe-honorario`)
  },
}
